// Render a button
import React, { forwardRef } from "react";

const buttonAction = (e, location) => {
  e.preventDefault();
  document.location = location;
};

const Button = forwardRef((props, ref) => {
  let location;
  let label;
  let style = "secondary";
  let method = "redirect";
  switch (props.action) {
    case "save":
      method = "submit";
      label = "SAVE CHANGES";
      style = "primary";
      break;
    case "cancel":
      location = "/members/";
      label = "CANCEL";
      break;
    case "join":
      method = "submit";
      label = "AGREE AND JOIN";
      style = "primary";
      break;
    case "donate":
      method = "submit";
      label = "DONATE";
      style = "primary";
      break;
    case "changeLevel":
      location = "/members/change";
      label = "CHANGE MEMBERSHIP LEVEL";
      break;
    case "upgradeLevel":
      location = "/upgrade";
      label = "UPGRADE";
      style = "primary";
      break;
    case "makeDonation":
      location = "/donate";
      label = "DONATE";
      break;
    case "changePassword":
      location = "/members/password";
      label = "CHANGE PASSWORD";
      break;
    case "cancelMembership":
      method = "submit";
      label = "CANCEL MY MEMBERSHIP";
      style = "destructive";
      break;
    case "editProfile":
      location = "/members/profile";
      label = "EDIT PROFILE";
      break;
    case "billingSettings":
      location = "/members/billing";
      label = "BILLING SETTINGS";
      break;
    case "memberCenter":
      location = "/members/";
      label = "MEMBER CENTER";
      style = "primary";
      break;
    case "sendResetLink":
      method = "submit";
      style = "primary";
      label = "SEND RESET LINK";
      break;
    case "signIn":
      method = "signin";
      label = "Sign In";
      break;
    case "cancelReset":
      location = "/members/signin";
      label = "CANCEL";
      break;
  }
  if (method == "submit") {
    return (
      <input
        type="submit"
        id="submitButton"
        className={style}
        value={label}
        ref={ref}
      />
    );
  } else if (method == "signin") {
    return <input type="submit" className={style} value={label} />;
  } else {
    return (
      <button
        onClick={(e) => {
          buttonAction(e, location);
        }}
        className={style + " button"}
      >
        {label}
      </button>
    );
  }
});
export default Button;
